export default __webpack_public_path__ + "static/media/room1.c17f56a1.jpg";